/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import {
  RewardAlreadySubmitted,
  RewardPasswordPopup,
  CtaModal,
  CagTypography,
  CagTypographyVariant,
  HtmlParser,
} from '@hyphengroup/cag-components';
import {
  rewardThankYouModalOnLoad,
  rewardThankYouModalCta,
  rewardThankYouModalClose,
  rewardRedeemThankYouModalOnLoad,
  rewardRedeemThankYouModalCta,
  rewardRedeemThankYouModalClose,
  loginDashboardRewardsRedeemWithPasscodeAbandonEvent,
  loginDashboardRewardsRedeemWithPasscodeEvent,
} from 'components/tracking';
import {
  getComponentConfig,
  getImages,
  getStaticText,
} from 'helpers/Utils';

const withRewards = (WrappedComponent) => defaultProps => {
  const {
    dashboardQuery, track, location,
  } = defaultProps || {};

  const images = getImages(dashboardQuery);

  const {
    showRewardThankYouModal,
    showInsuranceRedemptionSuccessModal,
  } = location.state || {};

  const {
    REWARDS_THANK_YOU_MODAL: configRewardsThankYou,
  } = getComponentConfig(dashboardQuery) || {};

  const [showThankYouModal, setThankYouModal] = useState(null);
  useEffect(() => {
    if (showRewardThankYouModal && !dashboardQuery.loading) {
      if (showRewardThankYouModal.flow === 'REGISTER') {
        rewardThankYouModalOnLoad(
          track, showRewardThankYouModal.product, showRewardThankYouModal.campaign
        );
      }
      if (showRewardThankYouModal.flow === 'REDEEM') {
        rewardRedeemThankYouModalOnLoad(track);
      }
      setThankYouModal(showRewardThankYouModal);
    }
  }, [dashboardQuery.loading]);

  const [showSuccessModal, setShowSuccessModal] = useState(null);
  useEffect(() => {
    if (showInsuranceRedemptionSuccessModal) {
      setShowSuccessModal(true);
    }
  }, []);

  const [rewardPasswordModal, setRewardPasswordModal] = useState({
    isOpen: false,
    fulfilment: null,
    rewardHeader: null,
  });

  const staticText = getStaticText(dashboardQuery);

  function toggleRewardPasswordModal(fulfilment, rewardHeader) {
    setRewardPasswordModal((prev) => ({
      isOpen: !prev.isOpen,
      fulfilment: !prev.isOpen ? fulfilment : null,
      rewardHeader,
    }));
  }

  const props = {
    setRewardPasswordModal,
    toggleRewardPasswordModal,
    ...defaultProps,
  };

  return (
    <>
      <WrappedComponent {...props} />

      {showThankYouModal && showThankYouModal?.flow === 'REGISTER' && (
      <RewardAlreadySubmitted
        heroImage={{
          title: images.LOGIN_EMAIL_HERO?.image?.filename,
          url: images.LOGIN_EMAIL_HERO?.image?.url,
        }}
        staticText={{
          REWARD_SUBMITTED_HEADER:
                            configRewardsThankYou?.REWARDS_THANK_YOU_HEADER.text,
          REWARD_SUBMITTED_DESCRIPTION:
                            configRewardsThankYou?.REWARDS_THANK_YOU_DESCRIPTION.text.replace('$provider_name', showThankYouModal?.provider),
          REWARD_SUBMITTED_CTA:
                            configRewardsThankYou?.REWARDS_THANK_YOU_CTA.text,
        }}
        handlers={{
          onClick: () => {
            rewardThankYouModalCta(track);
            setThankYouModal(false);
            if (showThankYouModal?.link) {
              const win = window.open(showThankYouModal?.link, '_blank');
              win.focus();
            }
          },
          onClose: () => {
            rewardThankYouModalClose(track);
            setThankYouModal(false);
          },
        }}
      />
      )}
      {showThankYouModal && showThankYouModal?.flow === 'REDEEM' && (
      <RewardAlreadySubmitted
        heroImage={{
          title: images.LOGIN_EMAIL_HERO?.image?.filename,
          url: images.LOGIN_EMAIL_HERO?.image?.url,
        }}
        staticText={{
          REWARD_SUBMITTED_HEADER:
                          configRewardsThankYou?.REWARDS_FORM_SUCCESS_HEADER.text,
          REWARD_SUBMITTED_DESCRIPTION:
                          configRewardsThankYou?.REWARDS_FORM_SUCCESS_DESCRIPTION.text.replace('$provider_name', showThankYouModal?.provider),
          REWARD_SUBMITTED_CTA:
                          configRewardsThankYou?.REWARDS_FORM_SUCCESS_CTA.text,
          REWARD_SUBMITTED_REMARK:
                          configRewardsThankYou?.REWARDS_FORM_SUCCESS_REMARK.text,
        }}
        handlers={{
          onClick: () => {
            rewardRedeemThankYouModalCta(track);
            setThankYouModal(false);
          },
          onClose: () => {
            rewardRedeemThankYouModalClose(track);
            setThankYouModal(false);
          },
        }}
      />
      )}
      {rewardPasswordModal.fulfilment && (
      <RewardPasswordPopup
        staticText={{
          REWARD_PASSWORD_POPUP_TITLE_LABEL:
                                staticText.REWARD_PASSWORD_POPUP_TITLE_LABEL,
          REWARD_PASSWORD_POPUP_DESCRIPTION_LABEL:
                                staticText.REWARD_PASSWORD_POPUP_DESCRIPTION_LABEL,
          REWARD_PASSWORD_POPUP_REWARD_TITLE_LABEL:
                                rewardPasswordModal.rewardHeader,
          REWARD_PASSWORD_POPUP_PASSWORD_LABEL:
                                staticText.REWARD_PASSWORD_POPUP_PASSWORD_LABEL,
          REWARD_PASSWORD_POPUP_CONFIRM_BUTTON_LABEL:
                                staticText.REWARD_PASSWORD_POPUP_CONFIRM_BUTTON_LABEL,
        }}
        heroImage={{
          title: images?.AUTH_DANCE?.image.title,
          url: images?.AUTH_DANCE?.image.url,
        }}
        password={rewardPasswordModal.fulfilment.password}
        isPopupShown={rewardPasswordModal.isOpen}
        handlers={{
          onClose: () => {
            toggleRewardPasswordModal();
            loginDashboardRewardsRedeemWithPasscodeAbandonEvent(track);
          },
          onConfirm: () => {
            window.open(rewardPasswordModal.fulfilment.url);
            loginDashboardRewardsRedeemWithPasscodeEvent(track);
          },
        }}
      />
      )}
      {showSuccessModal && (
      <CtaModal
        body={(
          <CagTypography
            dataSelector="dashboard-redemption-success-modal-description"
            variant={CagTypographyVariant.BODY}
          >
            <HtmlParser>
              {staticText.DASHBOARD_REDEMPTION_SUCCESS_MODAL_DESCRIPTION}
            </HtmlParser>
          </CagTypography>
                      )}
        ctaText={staticText.DASHBOARD_REDEMPTION_SUCCESS_MODAL_CTA}
        image={{
          title: images.DASHBOARD_REDEMPTION_SUCCESS_MODAL_HERO?.image?.filename,
          url: images.DASHBOARD_REDEMPTION_SUCCESS_MODAL_HERO?.image?.url,
        }}
        isOpen={showSuccessModal}
        onCtaClick={() => { setShowSuccessModal(false); }}
        onClose={() => { setShowSuccessModal(false); }}
        title={staticText.DASHBOARD_REDEMPTION_SUCCESS_MODAL_TITLE}
      />
      )}
    </>
  );
};

export default withRewards;
